import { SET_TRIM_DATA } from './types';

export function setTrimData(trimData) {
	return {
		type: SET_TRIM_DATA,
		payload: trimData
	};
}
